import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { IntegrationNotice } from '../IntegrationNotice'
import { useModals } from 'almanac-ui/Modal'
import Styles from '../IntegrationInitializationModal.module.scss'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Google } from 'blaze-ui/icons'

export const GoogleNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/12418084-connect-blaze-to-google-analytics"
    message={
      <div className={Styles.message}>
        Authorize Blaze to access your Google account.
        <div className={Styles.note}>Need help? Check our guide:</div>
      </div>
    }
  />
)

export const GoogleBusinessProfileNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/10208193-connect-blaze-to-google-business-profile"
    message={
      <div className={Styles.message}>
        You'll sign in with Google and grant Blaze access to your Business Profile to sync business info and insights.
        Access can be changed anytime.
      </div>
    }
  />
)

const GoogleInitialization = ({ useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const sharedProps = {
    notice: <GoogleNotice />,
    providerName: 'Google',
    onClose: closeModal,
    icon: <Google size={32} />,
    title: 'Connect Google Account',
    onConfirm: () => initiateOauth(ExternalIntegrationEnum.Google),
    primaryButtonText: 'Go to Google',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default GoogleInitialization
